import { render, staticRenderFns } from "./CourseDuration.vue?vue&type=template&id=680844d8&"
import script from "./CourseDuration.vue?vue&type=script&lang=ts&"
export * from "./CourseDuration.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports